export { PortalAutoformattingProvider } from './auto-formatting-provider';
